<!--
 * @Description: 单票下单
 * @Author: ganjia
 * @Date: 2019-10-15 14:10:50
 -->
<template>
  <div class="main-wrap singleOrder">
      <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="12">
              <h3>{{$lang('寄件人信息')}}</h3>
              <div class="group-content">
              <el-form-item :label="$lang('姓名')" prop="senderName">
                  <el-autocomplete
                      valueKey="name"
                      v-model="formData.senderName"
                      @select="changeSenderName"
                      :fetch-suggestions="remoteSenderName"
                      :placeholder="$lang('请输入寄件人姓名')">
                      <template slot="suffix">
                          <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
                      </template>
                  </el-autocomplete>
              </el-form-item>
              <el-form-item :label="$lang('联系电话')" prop="senderMobilePhone">
                <template slot="label"><span :title="$lang('联系电话')">{{$lang('联系电话')}}</span></template>
                  <el-autocomplete
                      valueKey="mobile"
                      @select="changeSenderName"
                      v-model="formData.senderMobilePhone"
                      :fetch-suggestions="remoteSenderMobilePhone"
                      :placeholder="$lang('请输入寄件人联系电话')"
                      :minlength="10"
                      :maxlength="13">
                  </el-autocomplete>
              </el-form-item>
              <el-form-item :label="$lang('公司名称')" prop="senderCompany">
                  <template slot="label"><span :title="$lang('公司名称')">{{$lang('公司名称')}}</span></template>
                  <el-input v-model="formData.senderCompany" :placeholder="$lang('请输入公司名称')"  :minlength="1"  :maxlength="100" />
              </el-form-item>
              <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="senderPostalCode">
                  <el-input v-model="formData.senderPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 1)"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('省/市/区')" prop="senderProvince"  class="el-form-item w360-inline el-form-item--small">
                <BaseAddress
                    ref="senderProvinceSearch"
                    :initAddressData="sendAddressData"
                    :showLevel="3"
                    :isDisabled="true"
                    v-model="formData.senderProvince"> </BaseAddress>
                <el-tooltip effect="dark" placement="bottom">
                    <span class="tooltip-click">?</span>
                    <div slot="content">
                        {{ $lang('区域为空？') }}<br>
                        {{ $lang('存在邮编对应区域未开通，暂无法服务') }}
                    </div>
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="$lang('预约取件时间')" prop="times">
                <time-select
                    style="width: 100%; text-align: left;"
                    v-model="formData.times">
                </time-select>
              </el-form-item>
              <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址')" prop="senderDetailedAddress">
                  <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1"  :maxlength="201"></el-input>
                  <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
              </el-form-item>
              </div>
          </el-col>
          <el-col :span="12">
              <h3>{{$lang('收件人信息')}}</h3>
              <div class="group-content">
              <el-form-item :label="$lang('姓名')" prop="receiverName">
                <el-autocomplete
                  valueKey="name"
                  v-model="formData.receiverName"
                  @select="changeReceiverName"
                  :fetch-suggestions="remoteReceiverName"
                  :placeholder="$lang('请输入收件人姓名')">
                  <template slot="suffix">
                      <i class="iconfont icondizhibao pointer" @click="open(2)"></i>
                  </template>
                </el-autocomplete>
              </el-form-item>
              <el-form-item :label="$lang('联系电话')"  prop="receiverMobilePhone">
                    <template slot="label"><span :title="$lang('联系电话')">{{$lang('联系电话')}}</span></template>
                  <!-- <el-input v-model="formData.receiverMobilePhone" :maxlength='15'  :placeholder="$lang('请输入收件人联系电话')"></el-input> -->
                    <el-autocomplete
                        valueKey="mobile"
                        @select="changeReceiverName"
                        v-model="formData.receiverMobilePhone"
                        :fetch-suggestions="remoteReceiverMobilePhone"
                        :placeholder="$lang('请输入收件人联系电话')"
                        :minlength="10"
                        :maxlength="13">
                  </el-autocomplete>
              </el-form-item>
              <el-form-item :label="$lang('公司名称')" prop="receiverCompany">
                    <template slot="label"><span :title="$lang('公司名称')">{{$lang('公司名称')}}</span></template>
                  <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司名称')"  :minlength="1"  :maxlength="100" />
              </el-form-item>
              <el-form-item class="el-form-item w160 el-form-item--small" :label="$lang('邮编')" prop="receiverPostalCode">
                <el-input v-model="formData.receiverPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 2)"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('省/市/区')" prop="receiverProvince" class="w360-inline">
                  <BaseAddress
                      ref="receiverProvinceSearch"
                      :initAddressData="receiverAddressData"
                      :showLevel="3"
                      :isDisabled="true"
                      v-model="formData.receiverProvince"
                  > </BaseAddress>
                  <el-tooltip effect="dark" placement="bottom">
                    <span class="tooltip-click">?</span>
                    <div slot="content">
                        {{ $lang('区域为空？') }}<br>
                        {{ $lang('存在邮编对应区域未开通，暂无法服务') }}
                    </div>
                  </el-tooltip>
              </el-form-item>
              <el-form-item class="el-form-item el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
                  <el-input v-model="formData.receiverDetailedAddress" @change="changeReceiverDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')"  :minlength="1"  :maxlength="201"></el-input>
                  <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{$lang('保存至地址簿')}}</el-checkbox>
              </el-form-item>
              </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <h3>{{$lang('货物信息')}}</h3>
            <div class="group-content">
              <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
                <template slot="label"> <span :title="$lang('客户订单号')">{{$lang('客户订单号')}}</span></template>
                <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="50"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('支付方式')" prop="payment">
<!--                  <Base-Select v-model="formData.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"-->
<!--                      dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">-->
<!--                  </Base-Select>-->
                  <Base-Select  v-model="formData.payment"
                               :dic="customerPayments"
                               :placeholder="$lang('请选择')"
                               :props="{label:'name' ,value:'code',valueObj:true}">
                  </Base-Select>
                  <!-- <Base-Select v-model="formData.payment" :dic="payTypesDic" :placeholder="$lang('请选择')"  :props="{label:'name' ,value:'code',valueObj:true}"></Base-Select> -->
              </el-form-item>
              <!-- 0510新增快递类型 -->
              <el-form-item :label="$lang('快递类型')" prop="expressType">
                  <Base-Select v-model="formData.expressType" @change="getupStairsValue" :props="{label:'name',value:'code', res:'appProductTypeVOList',valueObj:true}"
                      dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                  </Base-Select>
              </el-form-item>
              <el-form-item :label="$lang('物品类型')" prop="goods" ref="goods">
                  <Base-Select v-model="formData.goods" @change="getupStairsValue" :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
                      dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                  </Base-Select>
              </el-form-item>
              <el-form-item :label="$lang('物品名称')" prop="goodsName">
                <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1"  :maxlength="100"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('物品重量(kg)')" prop="packageTotalWeight">
                <el-input-number v-model="formData.packageTotalWeight" @change="getupStairsValue" :label="$lang('描述文字')" :precision="2"  :min="0" :max="99999.90"></el-input-number>
              </el-form-item>

              <!-- 新增计算功能  -->
              <el-form-item>
                <template>
                  <div style="display: block; white-space: nowrap; color: #999; height: 22px; line-height: 16px;">
                      {{$lang('(长*宽*高*件数，cm)')}}:
                    <el-tooltip effect="dark" placement="bottom">
                      <span class="tooltip-click">?</span>
                      <div slot="content">
                        {{ $lang('件数可不输入，件数将依据总件数') }}<br>
                        {{ $lang('输入件数，总件数将会无效') }}
                      </div>
                    </el-tooltip>
                  </div>
                </template>
                <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 9999}" v-model="countParams" :placeholder="$lang('例：a*b*c*件数，允许多行，按回车换行')"></el-input>
              </el-form-item>

              <el-form-item label="">
                <el-button type="primary" size="small" style="margin-top: 30px" @click="countWeight">{{ $lang('计算') }}</el-button>
              </el-form-item>

              <el-form-item :label="$lang('总件数')" prop="packageNumber">
                <el-input-number v-model="formData.packageNumber" :label="$lang('描述文字')"  :min="1" :max="999" step-strictly @change="packageNumberChange"></el-input-number>
              </el-form-item>

              <el-form-item :label="$lang('总体积(m³)')" prop="packageTotalVolume">
                <el-input-number v-model="formData.packageTotalVolume" :min="0.001" :precision="3" :max="99.999" @change="countWeightTotal"></el-input-number>
              </el-form-item>

              <el-form-item :label="$lang('总体积重(kg)')">
                <el-input v-model="formData.packateVolume" disabled :min="0.00" :precision="2" :max="99999.90"></el-input>
              </el-form-item>

              <el-form-item :label="$lang('计费重量(kg)')">
                <el-input v-model="formData.packageChargeWeight" disabled :precision="2" :min="1.00" :max="99999.90"></el-input>
              </el-form-item>

              <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
                <Base-Select :clearable="false" v-model="formData.insured" :dic="insuredDic" :placeholder="$lang('请选择')" :disabled="formData.goodsTypeCode === 'bm111111' || formData.paymentModeCode === 'CC_CASH' || this.insuranceFlag === 1" @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
                <span class="btn-insured-text" v-if="formData.insured===0">{{$lang('温馨提醒：如您当前保价选择否，若在寄递过程中发生丢损，您最高可获得5倍运费赔付。')}}</span>
               <!-- <a class="btn-insured" @click="openInsured">{{$lang('保价声明')}}</a> -->
              </el-form-item>
              <el-form-item :label="$lang('物品价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
                <el-input-number v-model="formData.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="2" :controls="false" :min="0" ></el-input-number>
              </el-form-item>
              <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured===1 && userInfo.freightStatus === 1">
                <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
              </el-form-item>
              <!-- 是否签回单  :disabled="formData.paymentModeName === 'PP_PM' "-->
              <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
                <template slot="label"> <span :title="$lang('是否签回单')">{{$lang('是否签回单')}}</span></template>
                <Base-Select :clearable="false"
                  v-model="formData.signReceipt"
                  :dic="signReceiptDic"
                  :placeholder="$lang('请选择')"
                  @change="changeSignReceipt"
                  :props="{label:'name' ,value:'code'}">
                  </Base-Select>
              </el-form-item>
              <el-form-item :label="$lang('参考运费')" prop="standardValue" v-show="userInfo.freightStatus === 1">
                <el-input v-model="formData.standardValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('回单管理费')" prop="receiptFreight" v-show="formData.signReceipt===1 && userInfo.freightStatus === 1" >
                <el-input v-model="formData.receiptFreight" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('是否上楼')">
                <Base-Select :clearable="false"
                  v-model="formData.isUpstairs"
                  :dic="signReceiptDic"
                  :placeholder="$lang('请选择')"
                   @change="getupStairsValue"
                  :props="{label:'name' ,value:'code'}">
                  </Base-Select>
              </el-form-item>
              <el-form-item :label="$lang('是否电梯')" prop="isElevator" v-if="formData.isUpstairs === 1">
                <Base-Select :clearable="false"
                  v-model="formData.isElevator"
                  :dic="elevatorDic"
                  :placeholder="$lang('请选择')"
                  @change="getupStairsValue"
                  :props="{label:'name' ,value:'code'}">
                  </Base-Select>
              </el-form-item>
              <el-form-item :label="$lang('上楼费')" v-if="formData.isUpstairs === 1" v-show="userInfo.freightStatus === 1">
                 <el-input v-model="formData.upStairsValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item v-show="userInfo.freightStatus === 1" :label="$lang('总运费')" >
                 <el-input v-model="totalFreight" :placeholder="$lang('请输入')" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$lang('服务税')" v-show="userInfo.freightStatus === 1">
                <el-input v-model="taxes" :placeholder="$lang('请输入')" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$lang('派送方式')"  prop="dispatch">
                <Base-Select :clearable="false"
                  v-model="formData.dispatchCode"
                  :dic="dispatchCodeDic"
                  :placeholder="$lang('请选择')"
                  @change="getDispatchCodeValue"
                  :props="{label:'name' ,value:'code'}">
                  </Base-Select>
                
              </el-form-item>
              <br>
              <el-form-item :label="$lang('备注')" prop="remarks" class="el-form-item el-form-item--small" style="width:40%">
                <el-input v-model="formData.remarks" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="100" resize="none" ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

      </el-form>
      <div class="bc-bottom">
        <el-button type="primary" @click="saveSubmit('sizeForm')" :loading="keyBtn" class="h48">{{ $lang('立即下单') }}</el-button>
      </div>
    <!-- </div> -->
    <SmartSpot v-model="smartSpot"></SmartSpot>
    <AddressBook v-model="addrBook" :selectType="selectType" @single-row-select="singleRowSelect" ref='address'></AddressBook>
    <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>

  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@constants'
import { RULES, checkAddressFormat, integerWeight, checkGoodsName, isName } from '@utils/rules'
import { DIC } from '@constants'
import SmartSpot from './SmartSpot'
import AddressBook from './AddressBook'
import { vipOrderAdd, reqAddressList, getComCost, getSettlement, getComputationCost, getDefaultAddress, printOrders, getReceiptFee, queryAddressAnalysisAddress, getList, getSysAreaInfo, getupStairsValue, queryDispatch, getInsuranceFlag, getCustomerByCode, getServiceType, getSstByCode } from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'

import { mapActions } from 'vuex'

export default {
  name: 'SingleOrder',
  components: {
    SmartSpot,
    AddressBook,
    InsuredStatement,
  },
  data() {
    return {
      DIC,
      COM_HTTP: {
        reqAdd: vipOrderAdd,
      },
     
      showClick: false,
      printOptions: {
        btnTitle: '下单并打印',
        btnType: 'primary',
        isHideIcon: true,
      },
      printOrder: false,
      keyBtn: false,
      keyBtn1: false,
      getOrderId: '', // 获取下单并打印的订单id
      rules: {
        senderName: [RULES.requiredTrim, { validator: isName }],
        senderMobilePhone: [RULES.required, RULES.isNum, RULES.lengthTenThirdteen, RULES.checkPhone60],
        senderProvince: [RULES.requiredSelect],
        senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        receiverName: [RULES.requiredTrim, { validator: isName }],
        receiverMobilePhone: [RULES.required, RULES.isNum, RULES.lengthTenThirdteen, RULES.checkPhone60],
        receiverProvince: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        goods: [RULES.required],
        senderPostalCode: [RULES.required, RULES.lengthFive],
        receiverPostalCode: [RULES.required, RULES.lengthFive],
        goodsName: [RULES.requiredTrim, { validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        packageNumber: [RULES.required, { validator: integerWeight }],
        packageTotalVolume: [RULES.required],
        // packageNumber: [RULES.required],
        payment: [RULES.requiredSelect],
        insured: [RULES.requiredSelectInsured],
        expressType: [RULES.requiredSelect],
        isElevator: [RULES.requiredSelect],
      },
      addrBook: false,
      smartSpot: false,
      infoVisible: false, // 保价费声明弹窗
      defaultFormData: {

      },
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        senderProvince: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        senderPostalCode: '', // 寄件邮编,
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        receiverProvince: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        receiverPostalCode: '', // 收件邮编,
        insured: '', // 是否保价1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: 0, // 保价费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 1, // 物品重量,
        payment: { code: 'PP_PM', name: this.$lang('Bulanan'), id: 7, type: 'ZD106' }, // 支付方式
        paymentModeId: '7', // 支付方式id,
        paymentModeCode: 'PP_PM', // 支付方式编码,
        paymentModeName: this.$lang('PP_PM'), // 支付方式名称,
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        packageNumber: 1, // 件数,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        boxTotalPrice: 0, // 箱材总价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        // packageChargeWeight: 1, // 结算重量
        customerOrderId: '',
        senderCompany: '',
        receiverCompany: '',
        checkSenderFlag: '', // 寄件人保存至地址簿
        checkReceiverFlag: '', // 寄件人保存至地址簿
        signReceipt: 0, // 签回单 0否 1是
        receiptFreight: 0, // 回单金额
        packageTotalVolume: 0.000, // 总体积
        packageChargeWeight: 1.00, // 计费重量
        packateVolume: 0.00, // 体积重
        isUpstairs: 0, // 是否上楼
        upStairsValue: 0, // 上楼费
        isElevator: '', // 是否电梯,是1 否2
        times: '',
        dispatchCode:'101',
        dispatchName:'Delivery',
      },
      receiptFreight: 0,
      checkSenderFlag: false,
      checkReceiverFlag: false,
      initData: {
        url: '/oauth/sysRoleResource/getAppResources',
        type: 'app',
        leftText: this.$lang('未选权限'),
        rightText: this.$lang('已选权限'),
        rightOptText: this.$lang('全部权限'),
        exculdeIdsParam: 'resourceIds',
      },
      selectType: 1,
      sendAddressData: {
        formProps: {
          provinceIdProp: 'senderProvinceId',
          provinceNameProp: 'senderProvinceName',
          cityIdProp: 'senderCityId',
          cityNameProp: 'senderCityName',
          areaIdProp: 'senderAreaId',
          areaNameProp: 'senderAreaName',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'receiverProvinceId',
          provinceNameProp: 'receiverProvinceName',
          cityIdProp: 'receiverCityId',
          cityNameProp: 'receiverCityName',
          areaIdProp: 'receiverAreaId',
          areaNameProp: 'receiverAreaName',
        },
        defaultData: {},
      },
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      signReceiptDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      customerPayments: [],
      elevatorDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      dispatchCodeDic: [],

      // payTypesDic: [{ code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: this.$lang('寄付现结'), id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: this.$lang('到付现结'), id: 321, type: 'ZD106' }],
      countParams: '',
      appProductTypeVOList: [], // 轻抛系数列表
      insuranceFlag: 0,
      sysNetwork: {},
      sstFlag: false,
    }
  },

  created() {
    this.fromType = this.comeFrom
    if (this.id) {
      this.getDetail()
    }
    // 实时获取是否强制保价
    this.getInsuranceFlag()
    // 获取客户信息
    this.getCustomerByCode()
    // 获取回单金额
    this.getReceiptFee()
    // 寄件人默认信息
    this.getDefaultAddress({ type: 1 })
    // 收件人默认信息
    this.getDefaultAddress({ type: 2 })
    // 获取客户SST
    this.getSstByCode()
    // 暂时隐藏
    this.getServiceType()
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    // 计算服务税
    taxes() {
      if (this.sysNetwork.businessModelId === 32) {
        if (this.sstFlag) {
          return 0.00
        }
        // 查询 sst
        return ((this.formData.insuredValue + this.formData.receiptFreight + this.formData.upStairsValue + this.formData.standardValue) * 0.06).toFixed(2)
      }
      return ((this.formData.insuredValue + this.formData.receiptFreight + this.formData.upStairsValue) * 0.06).toFixed(2)
    },
    // 总运费显示
    totalFreight() {
      const standardValue = Number.parseFloat(this.formData.standardValue).toFixed(2)
      const insuredValue = Number.parseFloat(this.formData.insuredValue).toFixed(2)
      const receiptFreight = Number.parseFloat(this.formData.receiptFreight).toFixed(2)
      const upStairsValue = Number.parseFloat(this.formData.upStairsValue).toFixed(2)

      // 总运费 = 参考运费 + 保价费 + 回单费 + 上楼费 + 税费
      return (
        parseFloat(standardValue) +
          parseFloat(insuredValue) +
          parseFloat(receiptFreight) +
          parseFloat(upStairsValue) +
          parseFloat(this.taxes)
      ).toFixed(2)
    },

  },
  watch: {
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeCode === 'bm111111') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
    },
    // 支付方式
    async 'formData.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持保价
      if (val.code === 'CC_CASH') {
        Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.formData.insuredValue = 0
        this.formData.receiptFreight = 0
      }
    },
    async 'formData.expressType'(val) {
      const { code, name } = val
      Object.assign(this.formData, { expressTypeCode: code, expressTypeName: name })
      // 重新计算轻抛系数
      this.countWeightTotal()
      const res = await this.calcStandardCost(this.formData)
       Object.assign(this.formData, res)
    },
    // 运费计算
    async 'formData.senderProvince'(val) {
      const { receiverProvince, packageTotalWeight } = this.formData
      if (receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费计算
    async 'formData.receiverProvince'(val) {
      const { senderProvince, packageTotalWeight } = this.formData
      if (senderProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 计费重量
    async 'formData.packageChargeWeight'(val) {
      const { senderProvince, receiverProvince } = this.formData
      if (senderProvince && receiverProvince && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 箱材规格计算
    async 'formData.boxStandard'(val) {
      const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res, {
        // 箱材规格id
        boxStandardId,
        // 箱材规格名称
        boxStandardName,
        // 箱材单价
        boxPrice,
      })
    },
    // 箱材数量
    async 'formData.boxNumber'(val) {
      const { boxStandardId, boxStandardName, boxPrice } = this.formData
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res)
    },
    // 保价费计算
    async 'formData.declaredValue'(val) {
      this.keyBtn = true
      const { goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      this.keyBtn = false
    },
  },
  mounted() {
    // 轻抛系数列表
    this.getLightTossCoefficient()
  },
  methods: {
    ...mapActions(['UPDATE_PRINT_STOCK']),
    //选择派送方式
    getDispatchCodeValue(val){
        if(val){
      
          let name=''
          for(let i of this.dispatchCodeDic){
            if(val==i.code){
              name=i.desc
            }
          }
          this.formData.dispatchName=name
            // 计算运费
          this.calcStandardCost(this.formData)
        }
    },
    async getupStairsValue() { // 获取上楼费
      const { packateVolume } = this.formData
      this.formData.packageChargeWeight = packateVolume > this.formData.packageTotalWeight ? packateVolume : this.formData.packageTotalWeight

      if (this.formData.isElevator === '' || this.formData.isUpstairs === 0) {
        this.formData.upStairsValue = 0
        this.formData.isElevator = 0
        return
      }
      this.$refs['sizeForm'].validate(async valid => {
        if (valid) {
          this.keyBtn = true
          const params = {
            costNum: this.formData.packageNumber, // 件数
            costWeight: this.formData.packageChargeWeight, // 计费重量
            goodsCode: this.formData.goods.code, // 物品类型code
            isElevator: this.formData.isElevator, // 是否电梯,是1 否2
            productTypeCode: this.formData.expressType.code, // 产品类型code
          }
          const { code, data, msg } = await getupStairsValue(params)
          if (code === RESPONSE_SUCCESS) {
            this.formData.upStairsValue = data || 0
          } else {
            this.$message.error(msg)
          }
          this.keyBtn = false
        } else {
          setTimeout(() => {
            this.formData.isElevator = ''
          }, 0)
        }
      })
    },
    // 获取客户信息
    async getSstByCode() {
      // if (this.sysNetwork.businessModelId !== 32) {
      //   return
      // }
      const params = {
        code: this.userInfo.customerCode,
      }
      const { code, msg, data } = await getSstByCode(params)
      if (data) {
        this.sstFlag = true
      } else {
        this.sstFlag = false
      }
    },
    // 获取客户信息
    async getCustomerByCode() {
      const params = {
        code: this.userInfo.customerCode,
      }
      const { code, msg, data } = await getCustomerByCode(params)
      if (code === RESPONSE_SUCCESS) {
        this.customerPayments = [{ code: data.settlementCode, name: this.$lang(data.settlementName) }]
        this.sysNetwork = data.sysNetworkVO
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 通过邮编改变省市区
    async changeAddress(zipCode, type = 1) {
      if (zipCode.length !== 5 && zipCode.length !== 0) return
      const { code, msg, data } = await getSysAreaInfo({ zipCode: zipCode })
      if (code === RESPONSE_SUCCESS && data) {
        if (type === 2) {
          const { code, data } = await queryDispatch({ zipCode: zipCode })
          if (code !== RESPONSE_SUCCESS || !data || !data.deliverNetworkCode) {
            this.$message.warning(this.$lang('该收件地址邮编未开放'))
          }
        }
        this.handleProvice(data, type)
      } else if (!data) {
        this.$message.warning(this.$lang('请输入正确的邮编'))
        this.handleProvice(data, type)
      } else {
        this.$message.warning(msg)
      }
    },
    // 获取轻抛系数
    async getLightTossCoefficient() {
      const { code, data, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        if (data.appProductTypeVOList) {
          this.appProductTypeVOList = data.appProductTypeVOList
        }
      } else {
        this.$message.warning(msg)
      }
    },
    // 件数改变重新计算体积
    packageNumberChange() {
      if (this.countParams) {
        this.countWeight()
      }
      this.getupStairsValue()
    },
    // 计算体积
    countWeight() {
      if (!this.countParams) {
        // 没有输入
        this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
        return
      }
      const counts = this.countParams.split(/[(\r\n\s)\r\n\s]+/)
      let flag = true
      let packageTotalVolume = 0
      for (let i = 0; i < counts.length; i++) {
        const countList = counts[i].split('*')
        if (countList.length !== 3 && countList.length !== 4) {
          // 输入的乘号不足
          this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
          return
        }
        if (!this.formData.packageNumber && countList.length !== 4) {
          // 件数不存在
          this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
        }
        let res = 1
        for (let i = 0; i < countList.length; i++) {
          if (isNaN(+countList[i]) || countList[i].match(/^\s*$/)) {
            // 如果存在非数字输入
            this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
            flag = false
            break
          } else if (countList[i].length > 5) {
            this.$message.warning(this.$lang('最大值不超过五位数'))
            flag = false
            break
          } else if (countList[i].indexOf('.') > -1) {
            this.$message.warning(this.$lang('不支持小数点'))
            flag = false
            break
          } else {
            res *= Number(countList[i])
          }
        }
        if (flag) {
          // 计算完成
          if (countList.length === 3 && counts.length === 1) {
            res = res * this.formData.packageNumber
          }
          if (res.toFixed(3) > 99999000) {
            this.$message.warning(this.$lang('总体积超额，请重新填写'))
            return
          }
          packageTotalVolume = packageTotalVolume + parseFloat((res / 1000000).toFixed(3))
        }
      }
      if (packageTotalVolume > 0) {
        this.formData.packageTotalVolume = packageTotalVolume
      }
      if (flag) {
        this.countWeightTotal()
      }
    },
    // 轻抛系数计算体积重
    countWeightTotal() {
      const { expressTypeCode, packageTotalVolume, packageTotalWeight } = this.formData
      const list = this.appProductTypeVOList.filter(item => item.code === expressTypeCode)
      if (list.length > 0 && (packageTotalVolume || packageTotalVolume === 0)) {
        // 体积重=根据总体积/轻抛系数
        const packateVolume = (packageTotalVolume * 1000000 / list[0].lightThrowingCoefficient).toFixed(2)
        if (packateVolume > 99999.90) {
          this.$message.warning(this.$lang('体积重限额，请重新调整总体积'))
          return
        }
        this.formData.packateVolume = Number(packateVolume)
        this.formData.packageChargeWeight = packateVolume > packageTotalWeight ? packateVolume : packageTotalWeight
      }
      // 计算上楼费
      this.getupStairsValue()

      // 计算运费
      this.calcStandardCost(this.formData)
    },
    beforePrint() {
      const userInfo = this.userInfo
      if (userInfo.surfaceFormat === 1) {
        this.$alert(this.$lang('请先到我的资料里设置面单格式'), this.$lang('提示'), {
          confirmButtonText: this.$lang('确定'),
        })
        return
      } else {
        this.printOrder = true
        this.saveSubmit('sizeForm')
      }
    },
    // 获取打印数据
    async getPrintData(type) {
      const ids = [this.getOrderId]
      const params = { ids: ids, printType: type, isVip: true }
      const { code, msg, data } = await printOrders(params)
      if (code === 1) {
        if (data.length) this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        this.printOrder = false
        setTimeout(() => {
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return data || []
      } else {
        this.$message.error(this.$lang(msg))
        return []
      }
    },
    // // 获取打印数据
    // async getPrintData(type) {
    //   return [this.formData]
    // },
    discern(type) {
      let text
      switch (type) {
        case 0:
          if (!this.formData.analysisAddress) { return }
          text = this.formData.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  senderName: person,
                  senderMobilePhone: phonenum,
                  senderDetailedAddress: detail,
                  senderProvince: {
                    senderProvinceName: province,
                    senderProvinceId: provinceCode,
                    senderCityId: cityCode,
                    senderCityName: city,
                    senderAreaId: countyCode,
                    senderAreaName: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.formData.analysisAddress = ''
          break
        case 2:
          if (!this.formData.analysisAddress1) { return }
          text = this.formData.analysisAddress1
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  receiverName: person,
                  receiverMobilePhone: phonenum,
                  receiverDetailedAddress: detail,
                  receiverProvince: {
                    receiverProvinceName: province,
                    receiverProvinceId: provinceCode,
                    receiverCityId: cityCode,
                    receiverCityName: city,
                    receiverAreaId: countyCode,
                    receiverAreaName: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 3:
          this.formData.analysisAddress1 = ''
          break
        default:
          break
      }
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    // 运费计算
    async calcStandardCost(data2) {
      const { senderProvince, receiverProvince, packageChargeWeight, paymentModeId } = this.formData
      const result = {
        // 寄件省份id
        senderProvinceId: senderProvince.senderProvinceId,
        // 寄件省份名称
        senderProvinceName: senderProvince.senderProvinceName,
        // 寄件城市id
        senderCityId: senderProvince.senderCityId,
        // 寄件城市名称
        senderCityName: senderProvince.senderCityName,
        // 寄件区域id
        senderAreaId: senderProvince.senderAreaId,
        // 寄件区域名称
        senderAreaName: senderProvince.senderAreaName,
        // 收件省份id
        receiverProvinceId: receiverProvince.receiverProvinceId,
        // 收件省份名称
        receiverProvinceName: receiverProvince.receiverProvinceName,
        // 收件城市id
        receiverCityId: receiverProvince.receiverCityId,
        // 收件城市名称
        receiverCityName: receiverProvince.receiverCityName,
        // 收件区域id
        receiverAreaId: receiverProvince.receiverAreaId,
        // 收件区域名称
        receiverAreaName: receiverProvince.receiverAreaName,
      }
      const promises = [
        // 获取起始地址ID
        this.getSettlement(result.senderProvinceId, result.senderCityId, result.senderAreaId),
        // 获取目的地地址ID
        this.getSettlement(result.receiverProvinceId, result.receiverCityId, result.receiverAreaId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      if (this.formData.receiverPostalCode) {
        // 获取十字码
        const { code, data } = await queryDispatch({ zipCode: this.formData.receiverPostalCode })
        if (code !== RESPONSE_SUCCESS || !data || !data.deliverNetworkCode) {
          // this.$message.warning(this.$lang('该收件地址邮编未开放'))
        } else {
          // 派件网点
          this.formData.dispatchNetworkId = data.deliverNetworkId
        }
      }
      // 运费
      const obj = {}
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId) {
        // 获取运费
        const res = await this.getComCost(packageChargeWeight, startAddressId, endAddressId, paymentModeId, this.formData.dispatchNetworkId)
        if(res.cost){
          obj.standardValue = res.cost
        }else{
          obj.standardValue = 0
        }
        if(res.setWeight){
          obj.settlementWeight = res.setWeight
        }else{
          obj.settlementWeight = 0
        }
      }
      // 返回结果
      return {
        ...result,
        ...obj,
      }
    },
    // 获取默认地址
    async getDefaultAddress(param) {
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          this.singleRowSelect(data, param.type)
        }
        // this.defaultFormData = commonFun.deepClone(this.formData)
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 箱材规格计算
    async calcBoxStandard({ boxStandardId, boxStandardName, boxPrice } = {}) {
      const { boxNumber } = this.formData
      // 箱数量
      const boxTotalPrice = this.$common.floatNumSub(boxNumber ? boxNumber * boxPrice : 0)
      return {
        // 箱材总价格
        boxTotalPrice,
      }
    },
    // 打开地址
    open(selectType) {
      this.addrBook = true
      this.selectType = selectType
      const data = selectType === 1 ? this.curentSend : this.curentReceiver
      this.$refs.address.updateBtnStauts(data)
      this.$refs.address.initData()
    },
    singleRowSelect(data, type) {
      if (!data.areaId) {
        return
      }
      const { name, mobile, detailedAddress, companyName, zipCode } = data

      if (type === 1) { // 1寄件2取件
        this.formData.senderName = name // 寄件人姓名,
        this.formData.senderMobilePhone = mobile // 寄件人邮编
        this.formData.senderPostalCode = zipCode + '' // 寄件人手机号
        this.formData.senderDetailedAddress = detailedAddress // 寄件详细地址
        this.formData.senderCompany = companyName
        this.curentSend = data
        this.handleProvice(data, type)
      } else if (type === 2) {
        this.formData.receiverName = name // 收件人姓名,
        this.formData.receiverMobilePhone = mobile // 收件人手机号
        this.formData.receiverPostalCode = zipCode + '' // 收件人邮编
        this.formData.receiverDetailedAddress = detailedAddress // 收件详细地址
        this.formData.receiverCompany = companyName
        this.curentReceiver = data
        this.handleProvice(data, type)
      }
    },
    /**
     * 是否保价
     */
    changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.declaredValue = ''
        this.formData.insuredValue = 0
      }
    },
    /**
    * 是否签回单
    */
    changeSignReceipt(val) {
      if (val === 0) {
        this.formData.receiptFreight = 0
      } else if (val === 1) {
        this.formData.receiptFreight = this.receiptFreight
      }
    },
    // 收件人姓名或者电话改变
    changeReceiverName(item) {
      this.formData.receiverName = item.name
      this.formData.receiverMobilePhone = item.mobile
      this.formData.receiverCompany = item.companyName
      this.formData.receiverPostalCode = item.zipCode + ''
      this.formData.receiverDetailedAddress = item.detailedAddress
      this.handleProvice(item, 2)
    },
    // 寄件人姓名或者电话改变
    changeSenderName(item) {
      this.formData.senderName = item.name
      this.formData.senderMobilePhone = item.mobile
      this.formData.senderCompany = item.companyName
      this.formData.senderPostalCode = item.zipCode + ''
      this.formData.senderDetailedAddress = item.detailedAddress
      this.handleProvice(item, 1)
    },
    // 表单保存 下单并保存
    // savePrintSubmit(formName) {
    //   console.log('formName',)
    // },
    // 表单保存  立即下单
    async saveSubmit(formName) {
      const addrValidate = await this.changeReceiverDetailedAddress(this.formData.receiverDetailedAddress)
      if (addrValidate) {
        return
      }
     
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持保价'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('物品价值必须大于0'))
        return
      }
      if (this.formData.isUpstairs === 1 && !this.formData.upStairsValue && this.formData.upStairsValue !== 0) {
        this.$message.error(this.$lang('暂不支持上楼服务'))
        return
      }
      if (this.formData.standardValue === 0) {
        this.$message.error(this.$lang('未获取到客户报价'))
        return
      }
      //下单前重新计算运费 防止下单过快 运费算的不对
      await this.calcStandardCost(this.formData)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.printOrder) {
            this.keyBtn1 = true
          } else {
            this.keyBtn = true
          }
          if (this.formData.insured === 0) this.formData.declaredValue = ''
          // this.formData.packageChargeWeight = this.formData.packageTotalWeight
          this.formData.boxStandardCode = this.formData.boxStandard ? this.formData.boxStandard.code : ''
          // this.formData.boxNumber = this.formData.boxStandard ? this.formData.boxNumber : null
          this.formData.checkReceiverFlag = this.checkReceiverFlag ? 1 : 0
          this.formData.checkSenderFlag = this.checkSenderFlag ? 1 : 0
          this.formData.totalPackageVolume = this.formData.packageTotalVolume
          this.formData.senderName = this.formData.senderName.trim()
          this.formData.receiverName = this.formData.receiverName.trim()
          this.formData.taxes = this.taxes
          // console.log(this.formData)
          //验证通过后延迟半秒下单，给运费计算时间
          setTimeout(()=>{
            this.vipOrderAdd(this.formData)
          },500)
         
        } else {
          return false
        }
      })
    },
    async vipOrderAdd(reqData) { // 新增订单
      try {
        const resData = await vipOrderAdd(reqData)
        if (resData.code === RESPONSE_SUCCESS) {
          this.getOrderId = resData.data.id
          this.$message({
            message: this.$lang('下单成功！'),
            type: 'success',
          })
          if (this.printOrder) {
            const value = 'oneLinkPage'
            this.$refs.print.toPrint(value)
            this.keyBtn1 = false
          } else {
            this.keyBtn = false
          }

          // this.formData = commonFun.deepClone(this.defaultFormData)
          this.$refs.sizeForm.resetFields()
          this.checkSenderFlag = false
          this.checkReceiverFlag = false
          // 寄件人默认信息
          this.getDefaultAddress({ type: 1 })
          // 收件人默认信息
          this.getDefaultAddress({ type: 2 })
          this.countParams = ''
          this.formData.totalPackageVolume = 0
          this.formData.packageTotalVolume = 0
          this.formData.packateVolume = 0
          this.formData.packageChargeWeight = 1
          this.$router.push({ path: 'redirect/singleOrder' })
          // 实时获取是否强制保价
          this.getInsuranceFlag()
        } else if (resData.code === 149010023) {
          this.$message.warning(resData.msg)
          // this.formData.senderPostalCode = ''// 收件省份id,
          // this.formData.senderProvinceName = ''// 收件省份名称,
          // this.formData.senderCityId = ''// 收件城市id,
          // this.formData.senderCityName = ''// 收件城市名称,
          // this.formData.senderAreaId = '' // 收件区域id,
          // this.formData.senderAreaName = '' // 收件区域名称,
          // this.formData.senderProvince = '' // 收件区省/市/区
          // this.formData.senderProvince = ''
          this.keyBtn = false
        } else if (resData.code === 149010024) {
          this.$message.warning(resData.msg)
          // this.formData.receiverPostalCode = ''// 收件省份id,
          // this.formData.receiverProvinceId = ''// 收件省份id,
          // this.formData.receiverProvinceName = ''// 收件省份名称,
          // this.formData.receiverCityId = ''// 收件城市id,
          // this.formData.receiverCityName = ''// 收件城市名称,
          // this.formData.receiverAreaId = '' // 收件区域id,
          // this.formData.receiverAreaName = '' // 收件区域名称,
          // this.formData.receiverProvince = '' // 收件区省/市/区
          this.keyBtn = false
        } else {
          this.$message.error(this.$lang(resData.msg))
          this.keyBtn = false
        }
      } catch (error) {
        this.keyBtn1 = false
        this.keyBtn = false
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId, dispatchNetworkId) {
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 7:
            smModeType = 2
            break
          case 8:
            smModeType = 3
            break
          case 6:
            smModeType = 1
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, ...{ smMode: smModeType },productTypeCode:this.formData.expressType&&this.formData.expressType.code?this.formData.expressType.code:'', dispatchCode: this.formData.dispatchCode, dispatchNetworkId: dispatchNetworkId}
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 城市重新赋值
    handleProvice(row = {}, type) {
      const { areaId = '', areaName = '', cityId = '', cityName = '', provinceId = '', provinceName = '' } = row || {}
      if (type === 1) {
        const defaultData = {}
        defaultData.senderProvinceId = provinceId
        defaultData.senderProvinceName = provinceName
        defaultData.senderCityId = cityId
        defaultData.senderCityName = cityName
        defaultData.senderAreaId = areaId
        defaultData.senderAreaName = areaName
        Object.assign(this.sendAddressData, { defaultData })
      } else {
        const defaultData = {}
        defaultData.receiverProvinceId = provinceId
        defaultData.receiverProvinceName = provinceName
        defaultData.receiverCityId = cityId
        defaultData.receiverCityName = cityName
        defaultData.receiverAreaId = areaId
        defaultData.receiverAreaName = areaName
        Object.assign(this.receiverAddressData, { defaultData })
      }
    },
    // 收件人姓名模糊搜索
    async remoteReceiverName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(msg)
        this.loading = false
      }
    },
    // 收件人联系电话模糊搜索
    async remoteReceiverMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人姓名模糊搜索
    async remoteSenderName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人联系电话模糊搜索
    async remoteSenderMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
          // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },

    createFilter(queryString, type) {
      return disease => {
        return (
          disease[type].toLowerCase().indexOf(queryString.toLowerCase()) !== -1 // 改为===0 就是筛选的数据只是首字匹配的列表项，需要包含输入字的所有列表项改为！==-1
        )
      }
    },
   
    // 实时获取是否强制保价
    async getInsuranceFlag() {
      const params = {
        id: this.userInfo.id,
      }
      const { data, msg, code } = await getInsuranceFlag(params)
      if (code === RESPONSE_SUCCESS) {
        if (data === 1) {
          // 是否保价1是，0否,
          this.insuranceFlag = 1
          this.formData.insured = 1
          this.rules.declaredValue = [RULES.required, RULES.declaredValue]
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
      // this.insuranceFlag = 1
      // this.formData.insured = 1
    },

     // 获取派送方式
     async getServiceType() {
      let params={
        serviceId:15
      }
      const { data, msg, code } = await getServiceType(params)
      if (code === RESPONSE_SUCCESS) {
        if (data&&data.length>0) {
          debugger
            let tmpArr=[]
            let tmpObj={}
            for(let i of data){
              tmpObj={
                code:i.code,
                label:i.name,
                desc:i.name,
                name:i.name
              }
              tmpArr.push(tmpObj)
            }
            this.dispatchCodeDic=tmpArr
            console.log(this.dispatchCodeDic)
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    /**
     * @description 获取回单金额
     */
    async getReceiptFee() {
      const params = {
        customerCode: this.userInfo.customerCode,
      }
      const { data, msg, code } = await getReceiptFee(params)
      if (code === RESPONSE_SUCCESS) {
        this.receiptFreight = data
        // this.formData.receiptFreight = this.receiptFreight
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    async changeReceiverDetailedAddress(val) {
      if (val) {
        if (!val.includes(this.formData.receiverPostalCode)) {
          this.$message.error(this.$lang('邮编和详细地址的邮编不匹配'))
          return true
        }
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)

        var num1 = val.indexOf(this.formData.receiverPostalCode) - 1
        var num2 = val.indexOf(this.formData.receiverPostalCode) + this.formData.receiverPostalCode.length
        if ((val[num1] && numRe.test(val[num1])) || (val[num2] && numRe.test(val[num2]))) {
          this.$message.error(this.$lang('收件信息所输入的邮编与详细地址的邮编不匹配，请确保两个邮编是相同的。'))
          return true
        }
      }
      return false
    },
  },

}
</script>
<style lang="scss" scoped>
.bc-bottom {
  margin: 20px 0;
  text-align: center;
}
.singleOrder{
    padding: 0 24px;
    h3 {
        font-size: 20px
    }
    .width100{
        width: 100%;
    }
    .w360 {
        width: 100%;
      ::v-deep.el-input{
          width: 360px !important;
        }
    }
    .w180{
      // width: calc(20% + 160px);
      width: 400px;
      .el-input{
        width: 360px !important;
      }
    }
    .w160 {
      width: 200px;
      .custom-province{
        display: inline-block;
      }
      ::v-deep.el-select, .el-input {
        width: 160px !important;
      }
    }
    .w360-inline {
      width: 100%;
      .custom-province{
        display: inline-block;
      }
      ::v-deep.el-select, .el-input {
        width: 360px !important;
      }
    }
    .tooltip-click{
      margin-left: 5px;
      width: 18px;
      height: 18px;
      background: #197D3B;
      color: #fff;
      border-radius: 18px;
      text-align: center;
      line-height: 18px;
      display: inline-block;
    }

}

.group-title{
  border-bottom: 1px dashed #EEEEEE;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;
  .title{
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #E0BD7B;
  }
  .insert-info{
    display: inline-block;
    margin-left: 60px;
    position: relative;
    .icon{
      color: #E0BD7B;
      position: absolute;
      overflow: visible;
    }
    .text{
      color: #666666;
      margin-left: 20px;
    }
  }
}
.group-content{
    background: #f7f7f9;
    padding: 20px 20px 0px;
    border-radius: 8px;
  .el-textarea__inner{
    min-height: 60px;
  }
  .oper{
    position: absolute;
    right: 20px;
    bottom: 5px;
    cursor: pointer;
    color: #333;
    .red{
      color: red;
      margin-right: 20px;
    }
  }
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content{
  position: relative;
  .btn-insured{
    color: #e60012;;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    top: 34px;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    left: 10px;
    &:hover{
      text-decoration: underline;
    }
  }
  .btn-insured-text{
    color: #e60012;;
    font-size: 10px;
    cursor: pointer;
    position: absolute;
    top: 34px;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    left: 10px;
    transform: scale(1);
  }
}
.el-form-item.declaredValue {
  .el-input-number .el-input__inner{
    text-align: left;
  }
}
.singleOrder{
    .el-form-item__label{
        width: 180px !important;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}
</style>
